import React, { memo, useMemo } from 'react'
import { IProductCategory } from '../types'
import ProductCategoryForm from './ProductCategoryForm'

interface CreateProductCategoryModalProps {
  readonly customerId: number
}

const CreateProductCategoryModal: React.FC<CreateProductCategoryModalProps> = memo(({
  customerId
}) => {
  const newProductCategory: IProductCategory = useMemo(() => ({
    hsLocalTariffs: [],
    customerId,
    name: '',
  }), [customerId])

  return (
    <ProductCategoryForm
      productCategory={newProductCategory}
      isDisabled={false}
    />
  )
})

CreateProductCategoryModal.displayName = 'CreateProductCategoryModal'

export default CreateProductCategoryModal
